export function isConsentRequiredOnClient(): boolean {
  if (typeof window === 'undefined') return false
  return (window as any).__CONSENT_REQUIRED__ === true
}
